<template>
  <div class="no-records">
    <img src="../../../assets/img/no-record.png" />
    <span>暂无记录</span>
  </div>
</template>

<script>
export default {
  name: 'noData'
}
</script>

<style lang="less" scoped>
.no-records {
  padding: 2rem 0;
  font-size: @fz34;
  color: #8C8C8C;
  .flex-center;
  img {
    width: 0.83rem;
    height: 0.95rem;
    margin-right: 0.2rem;
  }
}
</style>
